import React from 'react';
import { Col, Row, Form, Button, InputGroup, Dropdown, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEnvelope, faPhone, faEye, faEyeSlash, faKeySkeleton, faHexagonCheck, faGlobe } from "@fortawesome/pro-solid-svg-icons";
import MaskedInput from "react-text-mask";
import { Checkbox } from 'primereact/checkbox';

import captchaRefreshIco from '../../../../assets/img/icon-set-refresh.svg';
import fluentarrow from '../../../../assets/img/fluentarrow-trending.svg';
import receivemoney from '../../../../assets/img/receive-money.svg';

// Import our custom components
import FormField from './FormField';
import PolicyDialogs from './PolicyDialogs';
import { interestedProducts, investmentAmount, getCountryCode, countryItems } from '../helpers/locationData';
import '../Register.scss';

const RegisterStep1 = ({
    localRegisterInputs,
    handleChange,
    handleToggleSelect,
    fieldErrors,
    isChecked1,
    setIsChecked1,
    isChecked2,
    setIsChecked2,
    isShowPassword,
    handleMouseDownPassword,
    handleMouseUpPassword,
    isShowPasswordAgain,
    handleMouseDownPasswordAgain,
    handleMouseUpPasswordAgain,
    loginRedirect,
    registerClickStep1,
    reloadCaptcha,
}) => {
    const [visibleSecurityPol, setVisibleSecurityPol] = React.useState(false);
    const [visiblePrivacyPol, setVisiblePrivacyPol] = React.useState(false);

    return (
        <Row className="m-t-30">
            <Col lg="12">
                <PolicyDialogs
                    visibleSecurityPol={visibleSecurityPol}
                    setVisibleSecurityPol={setVisibleSecurityPol}
                    visiblePrivacyPol={visiblePrivacyPol}
                    setVisiblePrivacyPol={setVisiblePrivacyPol}
                />
                <div>
                    <Row>
                        <Form>
                            <Form.Group className="mb-3" id="city-dropdown">
                                <InputGroup className="user-password-input-group w-100">
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                                        <Dropdown data-bs-theme="dark">
                                            <Image className="userLoginKeyIcon" src={fluentarrow} fluid />
                                            <Dropdown.Toggle
                                                variant="secondary"
                                                className="w-100"
                                                style={{
                                                    color: localRegisterInputs.interestedProducts.length > 0 ? '' : 'gray'
                                                }}>
                                                {
                                                    localRegisterInputs.interestedProducts.length > 0
                                                        ? localRegisterInputs.interestedProducts.map((item) => item.name).join(", ")
                                                        : "İlgilendiğiniz ürünler"
                                                }
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu">
                                                {interestedProducts.map((item) => (
                                                    <Dropdown.Item
                                                        key={item.id + '-' + item.name}
                                                        onClick={() => handleToggleSelect(item)}
                                                        className={localRegisterInputs.interestedProducts.some((el) => el.id === item.id)
                                                            ? "comboActiveItem"
                                                            : ""}>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span>{item.name}</span>
                                                            {localRegisterInputs.interestedProducts.some((el) => el.id === item.id) && (
                                                                <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />
                                                            )}
                                                        </div>
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    </Row>

                    <Row>
                        <Form>
                            <Form.Group className="mb-3" id="city-dropdown">
                                <InputGroup className="user-password-input-group w-100">
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                                        <Dropdown data-bs-theme="dark">
                                            <Image className="userLoginKeyIcon" src={receivemoney} fluid />
                                            <Dropdown.Toggle
                                                variant="secondary"
                                                className="w-100"
                                                style={{
                                                    color: localRegisterInputs.investmentAmount.name ? '' : '#808080'
                                                }}>
                                                {localRegisterInputs.investmentAmount.name || "Yatırımda değerlendirmeyi düşündüğünüz tutar"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu">
                                                {investmentAmount.map((item) => (
                                                    <Dropdown.Item
                                                        key={item.id + '-' + item.name}
                                                        onClick={(e) => handleChange("investmentAmount", item)}
                                                        className={item.id === localRegisterInputs.investmentAmount.id ? "comboActiveItem" : ""}>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span>{item.name}</span>
                                                            {item.id === localRegisterInputs.investmentAmount.id &&
                                                                <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />
                                                            }
                                                        </div>
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    </Row>

                    <Row className="m-t-0">
                        <div className="d-flex">
                            <Form.Group className="mb-3" id="ControlInput0">
                                <InputGroup className={`user-mail-input-group w-100 ${fieldErrors.name ? 'input-error' : ''}`}>
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                        <FontAwesomeIcon icon={faUser} className="userLoginUserIcon" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        id="user-name"
                                        type="text"
                                        className="customRegisterInput"
                                        placeholder="Ad"
                                        value={localRegisterInputs.name}
                                        onChange={(e) => handleChange("name", e.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>
                            <Form.Group className="mb-3 m-l-10" id="ControlInput0">
                                <InputGroup className={`user-mail-input-group w-100 ${fieldErrors.surname ? 'input-error' : ''}`}>
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                        <FontAwesomeIcon icon={faUser} className="userLoginUserIcon opacity-0 absolute" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        id="user-surname"
                                        type="text"
                                        className="customRegisterInput surnameInput"
                                        placeholder="Soyad"
                                        value={localRegisterInputs.surname}
                                        onChange={(e) => handleChange("surname", e.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>
                        </div>
                    </Row>

                    <Row>
                        <Form>
                            <Form.Group className="mb-3" id="city-dropdown">
                                <InputGroup className="user-password-input-group w-100">
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                                        <Dropdown data-bs-theme="dark">
                                            {localRegisterInputs.country.sCode != "empty" ? (
                                                <Image
                                                    src={localRegisterInputs.country.flag || `/assets/img/flags/${localRegisterInputs.country.sCode}.svg`}
                                                    className="userLoginKeyIcon"
                                                    style={{ width: '36px', height: '37px', }}
                                                    fluid
                                                />
                                            ) : (
                                                <FontAwesomeIcon icon={faGlobe} className="userLoginKeyIcon" />
                                            )}
                                            <Dropdown.Toggle
                                                variant="secondary"
                                                className="w-100"
                                                style={{
                                                    color: localRegisterInputs.country.name ? '' : 'gray'
                                                }}>
                                                {localRegisterInputs.country.name ?
                                                    `(+${getCountryCode(localRegisterInputs.country.name)}) ${localRegisterInputs.country.name}`
                                                    : "Ülke Seçiniz"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu">
                                                {countryItems.map((item) => (
                                                    <Dropdown.Item
                                                        key={item.id + '-' + item.name}
                                                        onClick={() => handleChange("country", item)}
                                                        className={item.id === localRegisterInputs.country.id ? "comboActiveItem" : ""}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="d-flex align-items-center">
                                                                {item.sCode && item.sCode !== "empty" ? (
                                                                    <img
                                                                        src={item.flag || `/assets/img/flags/${item.sCode}.svg`}
                                                                        alt={item.name}
                                                                        style={{ width: '24px', height: '24px', marginRight: '8px', borderRadius: '3px' }}
                                                                    />
                                                                ) : (
                                                                    <FontAwesomeIcon icon={faGlobe} style={{ marginRight: '8px' }} />
                                                                )}
                                                                <span>{item.name}</span>
                                                            </div>
                                                            {item.id === localRegisterInputs.country.id && (
                                                                <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />
                                                            )}
                                                        </div>
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    </Row>

                    <Row>
                        <Form.Group className="mb-3" id="ControlInput2">
                            <InputGroup className={`user-mail-input-group w-100 ${fieldErrors.phone ? 'input-error' : ''}`}>
                                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                    <FontAwesomeIcon icon={faPhone} className="userLoginUserIcon" />
                                </InputGroup.Text>
                                <MaskedInput
                                    id="user-phone"
                                    type="text"
                                    name="phoneNumber"
                                    className="form-control customRegisterInput"
                                    placeholder="(5 _ _ ) _ _ _ _ _ _ _"
                                    guide={true}
                                    mask={["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                                    value={localRegisterInputs.phone}
                                    onChange={(e) => handleChange("phone", e.target.value)}
                                />
                            </InputGroup>
                        </Form.Group>
                    </Row>

                    <Row>
                        <Form.Group className="mb-3" id="ControlInput1">
                            <InputGroup className={`user-mail-input-group w-100 ${fieldErrors.email ? 'input-error' : ''}`}>
                                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                    <FontAwesomeIcon icon={faEnvelope} className="userLoginUserIcon" />
                                </InputGroup.Text>
                                <Form.Control
                                    id="user-email"
                                    type="text"
                                    className="customRegisterInput"
                                    placeholder="E Posta Adresi"
                                    value={localRegisterInputs.email}
                                    onChange={(e) => handleChange("email", e.target.value)}
                                />
                            </InputGroup>
                        </Form.Group>
                    </Row>

                    <Row>
                        <Form>
                            <Form.Group className="mb-3" id="ControlInput7">
                                <InputGroup className={`user-password-input-group w-100 ${fieldErrors.password ? 'input-error' : ''}`}>
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                        <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        className="userLoginPassword customRegisterInput"
                                        value={localRegisterInputs.password}
                                        aria-label="Default"
                                        aria-describedby="inputGroup-sizing-default"
                                        type={isShowPassword ? "text" : "password"}
                                        placeholder="Şifre"
                                        name="password1"
                                        onChange={(e) => handleChange("password", e.target.value)}
                                    />
                                    <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                                        onMouseDown={handleMouseDownPassword}
                                        onMouseUp={handleMouseUpPassword}
                                        onMouseLeave={handleMouseUpPassword}
                                    >
                                        <FontAwesomeIcon icon={isShowPassword ? faEye : faEyeSlash} />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    </Row>

                    <Row>
                        <Form>
                            <Form.Group className="mb-3" id="ConGtrolInput7">
                                <InputGroup className={`user-password-input-group w-100 ${fieldErrors.passwordRetry ? 'input-error' : ''}`}>
                                    <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                        <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        className="userLoginPassword customRegisterInput"
                                        value={localRegisterInputs.passwordRetry}
                                        onChange={(e) => handleChange("passwordRetry", e.target.value)}
                                        aria-label="Default"
                                        aria-describedby="inputGroup-sizing-default"
                                        type={isShowPasswordAgain ? "text" : "password"}
                                        placeholder="Şifre Tekrar"
                                        name="password1"
                                    />
                                    <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                                        onMouseDown={handleMouseDownPasswordAgain}
                                        onMouseUp={handleMouseUpPasswordAgain}
                                        onMouseLeave={handleMouseUpPasswordAgain}
                                    >
                                        <FontAwesomeIcon icon={isShowPasswordAgain ? faEye : faEyeSlash} />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                        </Form>
                    </Row>

                    <Row>
                        <div className="captcha-wrapper mb-3">
                            <div className="cpth-label roboto-regular-14">Güvenlik Kodu</div>
                            <div className="captcha-inputs">
                                <div id="cpth-code-elm" className="cpth-code">GB</div>
                                <div className="cpth-relaod p-10 captcha-reload-hover" onClick={reloadCaptcha}>
                                    <img src={captchaRefreshIco} alt="refesg" width="24px" height="24px" />
                                </div>
                                <div className={`cpth-input ${fieldErrors.captcha ? 'input-error' : ''}`}>
                                    <Form.Control
                                        className="customRegisterInput"
                                        placeholder=""
                                        value={localRegisterInputs.captcha}
                                        type="text"
                                        onChange={(e) => handleChange("captcha", e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        <Col xs="12" className="d-flex">
                            <Checkbox
                                inputId="checkbox1"
                                checked={isChecked1}
                                onChange={(e) => setIsChecked1(e.checked)}
                                className="customCheckBox"
                            />
                            <label htmlFor="checkbox1" className="p-checkbox-label checkbox-label">
                                <a className="show-contract" onClick={(e) => { e.preventDefault(); setVisibleSecurityPol(true); }}>
                                    Gizlilik sözleşmesini
                                </a> ve&nbsp;
                                <a className="show-contract" onClick={(e) => { e.preventDefault(); setVisiblePrivacyPol(true); }}>
                                    Kişisel Verilerin Korunması Hakkında Bilgilendirme&nbsp;
                                </a>
                                metnini okudum, onaylanıyorum.
                            </label>
                        </Col>
                    </Row>

                    <Row className="m-t-15">
                        <Col xs="12" className="d-flex">
                            <Checkbox
                                inputId="checkbox2"
                                checked={isChecked2}
                                onChange={(e) => setIsChecked2(e.checked)}
                                className="customCheckBox"
                            />
                            <label htmlFor="checkbox2" className="p-checkbox-label checkbox-label">
                                Osmanlı Menkul tarafından sunulan hizmetlerle ilgili olarak, tarafıma reklam, promosyon,
                                kampanya ve benzeri ticari konulara ilişkin elektronik ileti gönderilmesini ve bu amaçla
                                yukarıda paylaştığım iletişim bilgileri üzerinden benimle iletişime geçilmesini onaylıyorum.
                            </label>
                        </Col>
                    </Row>

                    <Row style={{ display: "inline" }} className="m-0 ">
                        <Button slot="end" variant="dark" className="custom-button m-t-30 m-b-15" onClick={registerClickStep1}>
                            KAYIT OL
                        </Button>
                    </Row>

                    <Col xs="6" className="userForgotPassword">
                        Hesabım var &nbsp;
                        <a className="loginPageBtn" onClick={loginRedirect}>
                            Giriş Yap.
                        </a>
                    </Col>
                </div>
            </Col>
        </Row>
    );
};

export default RegisterStep1;
